import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import {PieChart, Users, Settings as SettingsIcon, Share2, Crosshair, CheckCircle,} from 'react-feather';
import { Box, makeStyles, } from '@material-ui/core';
import Page from 'src/components/Page';
import Sidebar from './Engagements/ViewEngagement/components/Sidebar';
import Dashboard from './Dashboard';
import Workflows from './Workflows';
import Settings from './Settings';
import ListEngagements from './Engagements/ListEngagements';
import ListContacts from './Contacts/ListContacts';
import ViewContact from './Contacts/ViewContact';
import Routes from '../../components/Routes';
import ViewEngagement from './Engagements/ViewEngagement';
import WorkflowsCardList from './Workflows/WorkflowsCardList';
import WorkflowDashboard from "./Workflows/WorkflowDashboard";
import AllTasksForWorkflowLedger from "./Workflows/WorkflowDashboard/AllTasksForWorkflowLedger";
import TasksForTeamLedger from "./TasksForTeamLedger";
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: (theme.palette.background as any).dark,
        height: 'calc(100vh - 64px)',
        display: 'flex',
        flex: '1 1',
        overflow: 'hidden',
        position: 'relative',
    },
    content: {
        overflowY: 'scroll'
    },
    search: {
        marginLeft: theme.spacing(2)
    },
    header: {
        paddingLeft: 8,
    }
}));
const BasicLayout = ({ tabs, url, children }: any) => {
    const classes = useStyles();
    return <>
    
    
    <Sidebar tabs={tabs.filter((tab: any) => tab.label)} rootUrl={url}/>
    <Box flexGrow={1} className={classes.content} p={3}>
      {children}
    </Box>
  </>;
};
const tabs = [
    {
        route: '/',
        component: Dashboard,
        label: 'Dashboard',
        icon: PieChart,
        exact: true,
    },
    {
        route: '/engagements/:engagementId',
        component: ViewEngagement,
    },
    {
        route: '/engagements',
        component: ListEngagements,
        label: 'Engagements',
        icon: Crosshair,
    },
    {
        route: '/tasks',
        component: TasksForTeamLedger,
        label: 'Tasks',
        icon: CheckCircle,
    },
    {
        route: '/workflows/:workflowId/tasks',
        component: AllTasksForWorkflowLedger,
        layout: BasicLayout,
    },
    {
        route: '/workflows/:workflowId/dashboard',
        component: WorkflowDashboard,
        layout: BasicLayout,
    },
    {
        route: '/workflows',
        component: WorkflowsCardList,
        label: 'Workflows',
        icon: Share2,
    },
    {
        route: '/contacts/:accountId',
        component: ViewContact,
    },
    {
        route: '/contacts',
        component: ListContacts,
        label: 'Contacts',
        icon: Users,
    },
    {
        route: '/settings',
        component: Settings,
        label: 'Settings',
        icon: SettingsIcon,
    },
];

function AdminExperience() {
    const classes = useStyles();
    const { url } = useRouteMatch();
    return (
        <Page className={classes.root}>
          <Routes
              routes={tabs}
              defaultLayout={BasicLayout}
              url={url}
              defaultComponentProps={{
                    tabs,
                    url,
                }}
          />
        </Page>
    );
}
export default AdminExperience;
